<template>
  <div>
    <v-tooltip bottom v-if="!isLoaded">
      <v-btn slot="activator" icon small disabled><v-icon>payments</v-icon></v-btn>
      {{ $t('Debt / credit limit') }}
    </v-tooltip>

    <template v-else>
      <v-badge overlap :color="colorStatus" :value="isCreditLimit">
        <template v-slot:badge>
          <span class="caption">{{ ratio }}%</span>
        </template>

        <v-tooltip bottom id="dialog">
          <v-btn :icon="!isBigScreen" :flat="!isBigScreen" :color="colorStatus" small dark @click="dialog = !dialog" slot="activator">
            <v-icon v-if="isBigScreen">payments</v-icon>
            <v-icon v-else :color="isCreditLimit ? 'primary' : 'error'">payments</v-icon>
            <span v-if="isBigScreen" class="text-uppercase caption ml-2">
              <template v-if="isCreditLimit">{{ used }}/{{ limit }} {{ curcy }} ({{ printDateTime(date, 1) }})</template>
              <template v-else>{{ $t('No active contract') }}</template>
            </span>
          </v-btn>
          {{ $t('Debt / credit limit') }}
        </v-tooltip>
      </v-badge>

      <v-menu attach="#dialog" activator="#dialog" v-model="dialog" offset-y bottom left min-width="320px" nudge-bottom="6">
        <v-tooltip bottom>
          <v-card :color="colorStatus" to="/invoices" slot="activator">
            <v-card-text class="text-none body-1 white--text">
              <v-layout row wrap align-center>
                <v-flex shrink>
                  <v-icon dark>list_alt</v-icon>
                </v-flex>
                <v-flex class="text-xs-center">
                  <template v-if="isCreditLimit">
                    <span class="font-weight-black">{{ used }} / {{ limit }} {{ curcy }}</span><br>
                    {{ $t('actualized on') }}
                    {{ printDateTime(date) }} {{ $t('h') }}
                  </template>
                  <template v-else>
                    {{ $t('No active contract') }}
                  </template>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <span>{{ $t('Go to') }} {{ $t('invoice screen') }}</span>
        </v-tooltip>
      </v-menu>
    </template>

  </div>
</template>

<script>
import { printDateTime } from "./util.js";

export default {
  name: 'credit-limit',
  props: {
    value: { type: Object, default: null }
  },

  data() {
    return {
      used: null,
      limit: null,
      ratio: null,
      curcy: null,
      date: null,
      colorStatus: 'grey',
      //
      dialog: false,
      printDateTime
    };
  },

  computed: {
    isBigScreen() {
      return !this.$vuetify.breakpoint.lgAndDown;
    },
    isLoaded() {
      return !!this.value;
    },
    isCreditLimit() {
      return !!this.value && !!this.value.creditLimit;
    }
  },

  watch: {
    value: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    init() {
      if (this.value && this.value.creditLimit) {
        this.used  = Number((this.value.totalDebt.amount).toFixed(0));
        this.limit = Number((this.value.creditLimit.amount).toFixed(0));
        this.curcy = this.value.creditLimit.currency.symbol;
        this.date  = this.value.updatedAt;
        this.ratio = this.getRatio();
        this.colorStatus = this.getColorStatus();
      }
      else {
        this.used  = null;
        this.limit = null;
        this.curcy = null;
        this.date  = null;
        this.ratio = null;
        this.colorStatus = 'red';
      }
    },

    getRatio() {
      return Number((
        (this.used / this.limit) * 100
      ).toFixed(0));
    },

    getColorStatus() {
      let color = 'orange';
      if (this.ratio > 100) {
        color = 'red';
      }
      else if (this.ratio < 80) {
        color = 'green';
      }
      return color;
    }
  }
}
</script>

<style scoped>
.v-badge >>> .v-badge__badge {
  width: 32px;
  border-radius: 12px;
  margin-right: -4px;
}
</style>